import { makeStyles, Theme } from '@material-ui/core/styles';
export const useStyles = makeStyles(
  (theme: Theme) => ({
    price: {
      marginTop: '12px',
      display: 'flex',
      fontSize: '20px',
      fontWeight: 600,
      color: '#FF505F',
    },
    payButton: {
      display: 'flex',
      justifyContent: 'end',
      alignItems: 'center',
    },
    textBox: {
      fontWeight: 700,
      fontSize: '16px',
      width: '160px',
      display: 'inline-block',
    },
    btn1: {
      background: '#4CAF50',
      width: '100%',
      color: 'white',
      marginTop: theme.spacing(1),
      padding: '12px 22px',
      '& .MuiButton-label': {
        textTransform: 'none',
      },
      '&:hover': {
        background: '#4CAF50',
      },
    },
    manulInput: {
      width: '100%',
    },
    formText: {
      fontWeight: 700,
      fontSize: '14px',
      paddingBottom: '10px',
      color: 'black',
    },
    buttonCell: {
      padding: '0px',
    },
    button: {
      borderRadius: '0px',
      width: '100%',
      fontWeight: 'bold',
      textTransform: 'none',
      letterSpacing: 0.15,
      fontSize: 14,
    },
    paper: {
      backgroundColor: '#ffffff',
      padding: theme.spacing(3),
      boxShadow: theme.shadows[0],
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    btnBox: {
      display: 'flex',
      justifyContent: 'flex-start',
    },
    cellHead: {
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.87)',
      width: '25%',
      textTransform: 'uppercase',
    },
    cellContent: {
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '14px',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    remaining: {
      marginTop: '16px',
      fontSize: '16px',
      fontWeight: 500,
    },
    border: {
      border: '1px solid #E0E0E0',
    },
    formDesign: {
      padding: '4px 0px',
    },
    stripeStyle: {
      border: '1px solid #eee',
      padding: '12px',
      borderRadius: '5px',
      boxShadow: '0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%)',
    },
    address: {
      color: 'red',
    },
    chipcolor: {
      height: '100px',
      overflowY: 'auto',
      padding: '8px',
      '& .MuiChip-outlined': {
        backgroundColor: '#e0e0e0',
      },
      '& .MuiFormControl-fullWidth': {
        width: '100%',
      },
      '& .MuiInput-underline:before': {
        borderBottom: 'none',
      },
      '& .MuiInput-underline:after': {
        borderBottom: 'none',
      },
    },
    inputText: {
      fontSize: '16px',
      width: '100%',
      color: '#424770',
      fontWeight: 600,
      '&::placeholder': {
        color: '#aab7c4',
        fontWeight: 600,
      },
      '& .MuiInputBase-input': {
        border: '1px solid #eee',
        boxShadow: '0px 1px 1px rgb(0 0 0 / 3%), 0px 3px 6px rgb(0 0 0 / 2%)',
        borderRadius: '5px',
        padding: '12px',
        fontSize: '16px',
        color: '#424770',
        fontWeight: 600,
      },
      '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #eee',
      },
    },
  }),
  {
    index: 1,
  }
);
export const cardStyle = {
  style: {
    base: {
      fontSize: '16px',
      color: '#424770',
      fontWeight: 600,
      '::placeholder': {
        color: '#aab7c4',
        fontWeight: 600,
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};
